module.exports = __webpack_public_path__ + "img/avengers.c902f54f.svg";